import { render, staticRenderFns } from "./buyNetworkOther.vue?vue&type=template&id=2c8d3d47&scoped=true&"
import script from "./buyNetworkOther.vue?vue&type=script&lang=js&"
export * from "./buyNetworkOther.vue?vue&type=script&lang=js&"
import style0 from "./buyNetworkOther.vue?vue&type=style&index=0&id=2c8d3d47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d3d47",
  null
  
)

export default component.exports